module.exports = __webpack_public_path__ + "static/media/jose_walmir_goncalves_duque.3fa96d49.png";